import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';

import { useToast } from 'Store/toast';
import getExportOperatorBreaks from 'Api/report-attendance-operator-detail/getExportOperatorBreaks';

import getOperatorBreaksRequest from './model/request/getOperatorBreaksRequest';
import { exportReportText } from 'Const/report-attendance/text';
import { useLoader } from 'Store/loader';

const useGetExportOperatorBreaks = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (filter) => {
      onShowLoader({ variant: 'loader-primary' });
      const queries = getOperatorBreaksRequest(filter);

      const response = await getExportOperatorBreaks(queries);

      return { response };
    },
    onSuccess: ({ response }) => {
      const filename = `Report Attendance Operator Breaks.xlsx`;

      const blob = new Blob([response]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportReportText.successExportText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportReportText.failedExportText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useGetExportOperatorBreaks;
